import React from 'react'
import "./Contact.css"
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'

const Contact = () => {
    return (
        <>
            <Navbar />
            <div className='contact'>
                <div className="contact-header">
                    <h1>Contact Us</h1>
                </div>
                <main className="container">
                    <section className="contact-form">
                        <h2>Send Us a Message</h2>
                        <form action="https://formspree.io/f/mleyaeve"
                            method="POST">
                            <div className="form-group">
                                <label htmlFor="name">Name</label>
                                <input type="text" id="name" name="name" required />
                            </div>
                            <div className="form-group">
                                <label htmlFor="email">Email</label>
                                <input type="email" id="email" name="email" required />
                            </div>
                            <div className="form-group">
                                <label htmlFor="message" >Message</label>
                                <textarea id="message" name="message" rows="4" required></textarea>
                            </div>
                            <button type="submit" className="submit-button">Submit</button>
                        </form>
                    </section>
                    <section className="contact-info">
                        <h2>Contact Information</h2>
                        <p><strong>Email:</strong> info@example.com</p>
                        <p><strong>Phone:</strong> +1 (123) 456-7890</p>
                        <p><strong>Address:</strong> 123 Crimson St, City, Country</p>
                    </section>
                </main>
            </div>
            <Footer />
        </>
    )
}

export default Contact
